export default {
  rewards: {
    title: "Phần thưởng",
    claim: "Nhận",
    weeklyCashback: "Hoàn tiền hàng tuần",
    weeklyCashbackDesc: "Nhận lại một phần thua lỗ hàng tuần của bạn.",
    dailySpin: "Vòng quay hàng ngày",
    dailySpinDesc: "Quay vòng mỗi ngày để có cơ hội thắng giải lớn.",
    invitationBonus: "Thưởng mời bạn",
    invitationBonusDesc: "Mời bạn bè và nhận thưởng cho mỗi người tham gia.",
    rebate: "Hoàn cược",
    rebateDesc: "Nhận hoàn cược cho mỗi lần đặt cược, dù thắng hay thua.",
    bannerTitle: "PHẦN THƯỞNG",
    bannerSubtitle: "Hoàn thành nhiệm vụ và nhận phần thưởng tuyệt vời!",
    sectionTitle: "Phần thưởng tuyệt vời của bạn",
    goNow: "Đi ngay",
    historyReceived: "Tổng đã nhận",
    todayReceived: "Nhận hôm nay",
    cashbackDialog: {
      title: "Hoàn Tiền Cược",
      loading: "Đang tải...",
      empty: "Chưa có quy tắc hoàn tiền",
      level: "Cấp",
      amountRange: "Khoảng Tiền",
      rewardRate: "Tỷ Lệ Thưởng",
      rewardCap: "Giới Hạn Thưởng",
    },
    cards: {
      checkin: {
        title: "Điểm danh hàng ngày",
        subtitle: "Đăng nhập điểm danh mỗi ngày",
        description: "Các game thủ nhớ điểm danh mỗi ngày nhé~",
      },
      cashback: {
        title: "Hoàn tiền",
        subtitle: "Phần thưởng hoàn cược nền tảng",
      },
      rescue: {
        title: "Thưởng cứu trợ",
        subtitle: "Chơi 3 game tiền mặt",
        description: "Quỹ cứu trợ cho người chơi phá sản",
      },
      task: {
        title: "Nhiệm vụ",
        subtitle: "Hoàn thành nhiệm vụ nền tảng",
        description: "Nhiệm vụ nền tảng",
      },
      balance: {
        title: "Két sắt",
        subtitle: "Nhận lãi hàng ngày",
        description: "Két sắt nền tảng",
      },
      loan: {
        title: "Thưởng vay tiền",
        subtitle: "Vay dễ dàng",
        description: "Vay tiền nền tảng",
      },
    },
    checkIn: {
      dailySignIn: "ĐIỂM DANH HÀNG NGÀY",
      totalRewards: "TỔNG PHẦN THƯỞNG",
      headlineDaysBefore: "Điểm danh liên tục",
      headlineDaysAfter: "ngày,",
      headlineTailCumulative: "bỏ lỡ một ngày cũng không sao.",
      headlineTailDate: "bỏ lỡ ngày nào sẽ mất thưởng của ngày đó.",
      headlineCumulative: "Điểm danh {days} ngày để nhận thưởng lớn, bỏ lỡ một ngày không sao.",
      headlineDate: "Điểm danh {days} ngày, bỏ lỡ ngày nào sẽ mất thưởng của ngày đó.",
      headlineEmpty: "Điểm danh để nhận thưởng",
      title: "Điểm danh",
      modeCumulative: "Điểm danh tích lũy",
      modeDate: "Điểm danh theo ngày",
      rewards: "Phần thưởng",
      signedIn: "Đã điểm danh",
      day: "Ngày {n}",
      loading: "Đang tải...",
      empty: "Không có hoạt động điểm danh nào đang diễn ra.",
      btnCheckIn: "Điểm danh",
      btnSigned: "Đã xong",
      btnLocked: "Đã khóa",
      claimSuccess: "Điểm danh thành công, thưởng {amount} {currency} đã được cộng",
      claimFailed: "Điểm danh thất bại",
      alreadySigned: "Bạn đã điểm danh hôm nay",
      notLogin: "Vui lòng đăng nhập trước",
    },
  },
};
